import { FC } from 'react';
import { useElementSize } from 'usehooks-ts';

import ClippedBox, { POSITION } from '@/components/roomstay-blog-image-block/clipped-box';
import { formatDate } from '@/helpers/DateHelper';
import { Article } from '@/types/article';
import { LazyLoadImage } from '../lazy-load-image';

import styles from './article-hero.module.scss';

interface Props {
    article: Article;
}

const ArticleHero: FC<Props> = (props) => {
    const { article } = props;
    const [imageRef, { height }] = useElementSize();

    return (
        <div className={styles.container}>
            <ClippedBox
                configs={[
                    {
                        rad: Math.atan(160 / 1920),
                        position: POSITION.BottomRight,
                    },
                ]}
                className={styles.background}
                style={{
                    backgroundColor: article.backgroundColor,
                    maxHeight: `calc(100% - ${(height / 5) * 2}px)`,
                }}
            />
            <div className={styles.content}>
                <h1 className={styles.title}>{article.title}</h1>
                <div className={styles.overallInfo}>
                    <div className={styles.articleInfo}>
                        <div className={styles.author}>
                            <div className={styles.avatarContainer}>
                                {article.author?.leadImage ? <LazyLoadImage className={styles.avatar} imageUrl={article.author?.leadImage} objectFit="cover" /> : null}
                            </div>
                            <div>
                                <div className={styles.name}>{article.author?.name}</div>
                                <div className={styles.jobTitle}>{article.author?.jobTitle}</div>
                            </div>
                        </div>
                        <div className={styles.article}>
                            <div className={styles.category}>{article.categories?.map((category) => category.name).join(', ')}</div>
                            <div>{article.lastUpdated ? formatDate(article.lastUpdated) : null}</div>
                            {article.readingTime && <div>{`${article.readingTime} min${article.readingTime > 1 ? 's' : ''} read`}</div>}
                        </div>
                    </div>
                    {article.summary ? <div className={styles.summary} dangerouslySetInnerHTML={{ __html: article.summary }} /> : null}
                </div>
            </div>
            <div ref={imageRef} className={styles.imageContainer}>
                <div className={styles.imageBox}>
                    <div className={styles.imageContent}>
                        {/* <div
              className={styles.image}
              style={{ backgroundImage: `url(${article.leadPortraitImage})` }}
            /> */}
                        {article.leadPortraitImage ? <LazyLoadImage className={styles.image} imageUrl={article.leadPortraitImage} objectFit="cover" /> : null}
                    </div>

                    <div className={styles.arrow}>
                        <span />
                        <div>Scroll to read</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArticleHero;
